import React, { useEffect } from 'react';
import { Col, Row } from 'antd';

import { StatsWidget } from '../../../components/Charts/StatsWidget';
import { useAppSelector } from '../../../../../store';
import { colSettings, defaultMembers, getWidgets } from '../utils/options';
import { useLazyGetMembersQuery } from '../service/members.api';
import { selectAnalyticsFilters } from '../../../store/analyticFiltersSlice';

export const MembersStatistics = () => {
    const filters = useAppSelector(selectAnalyticsFilters);

    const [
        getMembers,
        { data: members = defaultMembers, isFetching, isLoading },
    ] = useLazyGetMembersQuery();

    useEffect(() => {
        if (filters) {
            const payload = {
                ...filters,
                community_id: Number(filters.chat) || null,
            };
            getMembers(payload, true);
        }
    }, [filters]);

    const widgetSettings = {
        width: 'auto',
        loading: isFetching || isLoading,
    };

    return (
        <Row gutter={[16, 16]}>
            {getWidgets(members).map((widget, idx) => (
                <Col key={idx} {...colSettings}>
                    <StatsWidget {...widgetSettings} {...widget} />
                </Col>
            ))}
        </Row>
    );
};
